import { Highlight } from '../Highlight';
import { fromCamelCaseToWords } from '../../misc/functions';
import type { Filters, Website } from '../../types';

interface WebsiteCellProps {
  column: string;
  websiteData: Website;
  host: string;
  filters: Filters;
}

export function WebsiteCell({
  column,
  websiteData,
  host,
  filters,
}: WebsiteCellProps) {
  return (
    <td data-title={fromCamelCaseToWords(column)} data-qa={column}>
      <a href={`https://${host}`} target="_blank" rel="noreferrer">
        <Highlight
          text={websiteData[column] as string}
          highlight={filters[column]}
        />
      </a>
    </td>
  );
}
